import { getSupportedFeatures } from '../get-supported-features.js';

const extend = Object.assign;
const now = () => {
    return new Date().getTime();
};
const addClass = (element, className) => {
    element.classList.add(className);
};
const convertToHtml = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.firstChild;
};
const prepend = (element, originElement) => {
    originElement.insertBefore(element, originElement.firstChild);
};
const wrapInner = (parent, wrapper) => {
    parent.appendChild(wrapper);
    while (parent.firstChild !== wrapper) {
        wrapper.appendChild(parent.firstChild);
    }
};
const hasNativeScrolling = () => {
    const { mobileOS } = getSupportedFeatures();
    return mobileOS.ios || mobileOS.android;
};
const wheelDeltaY = (e) => {
    const deltaY = e.wheelDeltaY;
    let delta;
    if (e.wheelDelta) { // Webkit and IE
        if (deltaY === undefined || deltaY) { // IE does not have deltaY, thus always scroll (horizontal scrolling is treated as vertical)
            delta = e.wheelDelta;
        }
    }
    else if (e.detail && e.axis === e.VERTICAL_AXIS) { // Firefox and Opera
        delta = (-e.detail) * 10;
    }
    return delta;
};

export { addClass, convertToHtml, extend, hasNativeScrolling, now, prepend, wheelDeltaY, wrapInner };
